export enum PlanningFeaturePhaseEnum {
  SPLIT,
  SPLIT_AND_ASSIGN
}
